<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="container">
        <template v-if="list.length > 0">
          <el-image
            style="width: 100%; height: 100%"
            :src="list[0]"
            :preview-src-list="list"
          >
          </el-image>
        </template>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import topPiece from "@/components/topPiece.vue";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    topPiece,
  },
  data() {
    return {
      langSet: "",
      list: [],
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    if (this.langSet == "en") {
      this.$set(
        this.list,
        0,
        "https://oss.chinadentalshow.com/xcx/20250904142235_1086_116.jpg"
      );
    } else {
      this.$set(
        this.list,
        0,
        "https://oss.chinadentalshow.com/xcx/20250904142236_1087_116.jpg"
      );
    }
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  .main_content {
    padding: 40px 0 60px;
    font-size: 18px;
    color: #000;
    line-height: 28px;
    .img_wrap {
      margin-bottom: 20px;
      .content_img {
        width: 100%;
      }
    }
  }
}
.profile_wrap {
  padding-top: 40px;
  .profile_list {
    width: 55%;
    .profile_item {
      font-weight: 600;
      font-size: 21px;
      color: #004190;
      line-height: 29px;
      margin-bottom: 50px;
      width: 50%;
      img {
        width: 40px;
        height: 40px;
        margin-top: 15px;
        margin-right: 10px;
      }
      .pro_text {
        width: 90%;
      }
      .num {
        font-family: Arial, Arial;
        font-weight: 900;
        font-size: 50px;
        color: #e62344;
        line-height: 70px;
        .text {
          margin-left: -12px;
        }
      }
    }
  }
  .right {
    width: 45%;
    > img {
      width: 100%;
      margin-bottom: 24px;
    }
  }
}

.list_wrap {
  padding: 40px 0;
  p {
    width: calc((100% - 81px) / 4);
    height: 50px;
    color: #000;
    font-size: 18px;
    margin: 0 27px 20px 0;
    text-align: center;
    line-height: 22px;
    background: #f7f8fa;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.join_btn {
  width: 366px;
  height: 68px;
  color: #fff;
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  line-height: 68px;
  cursor: pointer;
  margin: 0 auto 100px;
  background: url("../../assets/imgs/btn_bg.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 10px;
}
@media only screen and (max-width: 1280px) {
  .list_wrap p {
    font-size: 16px;
  }
  .profile_wrap .profile_list .profile_item .num {
    font-size: 46px;
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    .main_content {
      display: block;
      font-size: 0.27rem;
      line-height: 0.42rem;
      padding: 0.38rem 0 1.15rem;
      .content_img {
        width: 3.08rem;
        margin-right: 0;
        margin-bottom: 0.38rem;
      }
    }
  }
  .profile_wrap {
    display: block;
    padding-top: 0.56rem;
    .profile_list {
      width: 100%;
      .profile_item {
        width: 100%;
        font-size: 0.31rem;
        margin-bottom: 0.29rem;
        img {
          width: 0.58rem;
          height: 0.58rem;
          margin-right: 0.19rem;
          margin-top: 0.05rem;
        }
        .num {
          font-size: 0.54rem;
          line-height: 0.77rem;
          .text {
            margin-left: -6px;
          }
        }
      }
    }
    .right {
      width: 100%;
    }
  }
  .list_wrap {
    display: block;
    padding: 0.38rem 0;
    p {
      width: 100%;
      height: 0.88rem;
      font-size: 0.31rem;
      line-height: 0.88rem;
      margin-bottom: 0.19rem;
    }
  }
  .join_btn {
    width: 6.92rem;
    height: 1.15rem;
    font-size: 0.35rem;
    line-height: 1.15rem;
    margin-top: 1.15rem;
  }
}
</style>